import React from 'react'

function TinyArrowDown() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                d="M17.7 17.84a1 1 0 00-.92-.62h-3a.25.25 0 01-.28-.22V1.5a1.5 1.5 0 00-3 0V17a.25.25 0 01-.25.25h-3a1 1 0 00-.7 1.71l4.77 4.78a1 1 0 001.42 0l4.77-4.78a1 1 0 00.19-1.12z"
            ></path>
        </svg>
    )
}

export default TinyArrowDown
